import type { ReactElement, ReactNode } from 'react';

interface ResultsItemClasses {
  selected?: string;
  highlighted?: string;
}

export interface ResultsItemProps<Item = any> {
  children: NonNullable<ReactNode>;
  item: Item;
  className?: string;
  classes?: ResultsItemClasses;
}

export function ResultsItem({ children }: ResultsItemProps): ReactNode {
  return children as ReactElement; // "as ReactElement" to fix typescript
}
